// ThemeMount: a zero-render component that activates the useTheme hook so
// the user's selected theme is applied to :root globally, on every page.
import { useTheme } from '@/hooks/useTheme';

export default function ThemeMount() {
  useTheme();
  return null;
}
